<template>
  <VContainer
    fluid
    ma-0
    pa-0
  >
    <VLayout
      column
      fill-height
      class="show-border"
    >
      <VFlex
        xs12
      >
        <VLayout
          align-center
          justify-center
          row
          fill-height
        >
          <VFlex
            xs5
            sm5
            md3
            lg2
            class="tool"
          >
            <VCheckbox
              v-model="isSelectAll"
              class="checkbox"
              label="Select all"
              :indeterminate="indeterminate"
              hide-details
            />
          </VFlex>
          <VFlex
            xs5
            sm5
            md9
            lg10
          >
            <VLayout
              row
              align-center
              justify-end
            >
              <VFlex
                xs10
              >
                <span class="span">
                  Selected ({{ getSelectedContactsCount() }})
                </span>
              </VFlex>
              <VFlex
                xs2
              >
                <VLayout
                  row
                  justify-end
                >
                  <VBtn
                    small
                    icon
                    @click.prevent="openNewMassTextDialog"
                  >
                    <VIcon>
                      open_in_new
                    </VIcon>
                  </VBtn>
                </VLayout>
              </VFlex>
            </VLayout>
          </VFlex>
        </VLayout>
      </VFlex>
      <VFlex
        xs12
      >
        <TextBox
          ref="textBox"
          :submit-text="submitMassText"
          :sending="sending"
          :uploading-file="uploadingFile"
          show-file
        />
      </VFlex>
    </VLayout>
    <TimeFrameDialogCard
      :dialog.sync="timeFrameDialog"
      @submitClicked="onSubmitScheduleMessageClicked"
    />
    <ComposeNewMassMessagesDialog
      :dialog.sync="newMassMessageDialog"
    />
  </VContainer>
</template>

<script>
import _ from 'lodash'
import CONTACTS_WITH_WORK_QUERY from '@/backend/graphql/contact/ContactsWithWork.gql'
import { mapGetters, mapActions } from 'vuex'
import { massMessagePendingType } from '@/store/modules/message'
import TextBox from '@/components/TextBox'
import TimeFrameDialogCard from '@/components/TimeFrameDialogCard'
import ComposeNewMassMessagesDialog from '@/components/ComposeNewMassMessagesDialog'

export default {
  name: 'MassTextBox',
  components: { ComposeNewMassMessagesDialog, TextBox, TimeFrameDialogCard },
  props: {
    maxOneTimeMassMessages: {
      type: Number,
      default: 500
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Set,
      default: function () {
        return new Set()
      }
    },
    unselectedIds: {
      type: Set,
      default: function () {
        return new Set()
      }
    },
    getGqlQuery: {
      type: Object,
      default: function () {
        return CONTACTS_WITH_WORK_QUERY
      }
    },
    getQueryVariables: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      timeFrameDialog: false,
      indeterminate: false,
      newMassMessageDialog: false
      // scheduleStartTime: new Date().toLocaleTimeString(),
      // scheduleEndTime: new Date().toLocaleTimeString()
    }
  },
  computed: {
    ...mapGetters({
      sending: 'message/getMassSendingStatus',
      uploadingFile: 'message/getUploadingFile',
      allContacts: 'contact/getAllContacts',
      contactTotalCount: 'contact/getTotalCount'
    }),
    isSelectAll: {
      get () {
        return this.selectAll
      },
      set (val) {
        this.$emit('update:selectAll', val)
      }
    }
  },
  methods: {
    ...mapActions({
      sendMassMessages: 'message/sendMassMessages',
      sendMassMMS: 'message/sendMassMMS'
    }),
    getPendingType (queryName) {
      let pendingType = massMessagePendingType.normal
      switch (queryName) {
        case 'ActiveContactsWithWork':
          pendingType = massMessagePendingType.reply
          break
        case 'ListContactsQuery':
          pendingType = massMessagePendingType.reply
          break
        case 'ListCategoryContactsQuery':
          pendingType = massMessagePendingType.send
          break
        case 'ListInterestContactsQuery':
          pendingType = massMessagePendingType.send
          break
        case 'ListGroupContactsQuery':
          pendingType = massMessagePendingType.send
          break
        case 'ListChoiceProfile':
          pendingType = massMessagePendingType.send
          break
        default:
          break
      }
      return pendingType
    },
    submitMassText () {
      if (this.sending) return
      this.sendMassText()
    },
    sendMassText () {
      const queryName = _.get(this.getGqlQuery, 'definitions[0].name.value', '')
      const variables = this.getQueryVariables()
      const text = this.$refs.textBox.$refs.userInput.textContent.replace(/\s/g, '')
      const contactsCount = this.getSelectedContactsCount()
      const pendingType = this.getPendingType(queryName)
      if (this.$refs.textBox.file && contactsCount > 0) {
        if (contactsCount > this.maxOneTimeMassMessages) {
          this.timeFrameDialog = true
        } else {
          this.sendMassMMS({
            msgBody: this.$refs.textBox.$refs.userInput.textContent,
            file: this.$refs.textBox.file,
            selectAll: this.selectAll,
            selectedIds: this.selectedIds,
            unselectedIds: this.unselectedIds,
            contactId: _.get(this.allContacts, '[0].id', ''),
            pendingType,
            queryName,
            variables,
            contactsCount
          })
          this.$refs.textBox.$refs.userInput.innerHTML = ''
        }
      } else if (contactsCount > 0 && text && text.length > 0) {
        if (contactsCount > this.maxOneTimeMassMessages) {
          this.timeFrameDialog = true
        } else {
          this.sendMassMessages({
            msgBody: this.$refs.textBox.$refs.userInput.textContent,
            selectAll: this.selectAll,
            selectedIds: this.selectedIds,
            unselectedIds: this.unselectedIds,
            pendingType,
            queryName,
            variables,
            contactsCount
          })
          this.$refs.textBox.$refs.userInput.innerHTML = ''
        }
      }
    },
    onSubmitScheduleMessageClicked ({ startTime, endTime, timeZone }) {
      const queryName = _.get(this.getGqlQuery, 'definitions[0].name.value', '')
      const variables = this.getQueryVariables()
      const pendingType = this.getPendingType(queryName)
      const contactsCount = this.getSelectedContactsCount()
      if (this.$refs.textBox.file) {
        this.sendMassMMS({
          msgBody: this.$refs.textBox.$refs.userInput.textContent,
          file: this.$refs.textBox.file,
          selectAll: this.selectAll,
          selectedIds: this.selectedIds,
          unselectedIds: this.unselectedIds,
          contactId: _.get(this.allContacts, '[0].id', ''),
          startTime,
          endTime,
          timeZone,
          pendingType,
          queryName,
          variables,
          contactsCount
        })
        this.$refs.textBox.$refs.userInput.innerHTML = ''
      } else {
        this.sendMassMessages({
          msgBody: this.$refs.textBox.$refs.userInput.textContent,
          selectAll: this.selectAll,
          selectedIds: this.selectedIds,
          unselectedIds: this.unselectedIds,
          startTime,
          endTime,
          timeZone,
          pendingType,
          queryName,
          variables,
          contactsCount
        })
        this.$refs.textBox.$refs.userInput.innerHTML = ''
      }
    },
    getSelectedContactsCount () {
      if (this.contactTotalCount === 0) return 0
      if (this.isSelectAll) {
        this.indeterminate = (this.unselectedIds.size > 0) && (this.unselectedIds.size < this.contactTotalCount)
        this.isSelectAll = this.unselectedIds.size !== this.contactTotalCount
        return this.contactTotalCount - this.unselectedIds.size
      } else {
        this.indeterminate = (this.selectedIds.size > 0) && (this.selectedIds.size < this.contactTotalCount)
        this.isSelectAll = this.selectedIds.size === this.contactTotalCount
        return this.selectedIds.size
      }
    },
    openNewMassTextDialog () {
      this.newMassMessageDialog = true
    }
  }
}
</script>

<style scoped>
  .show-border {
    border: solid 2px #ddd
  }
  .tool{
    margin-left: 10px;
  }
  .checkbox {
    height: 35px;
    margin-top: 0px;
    padding-top: 6px;
  }
  .checkbox >>> label{
    font-size: small;
  }
  .span {
    font-size: small;
  }
</style>
